export default __webpack_public_path__ + "static/media/rflex-logo.e3067600.png";